import { useDispatch } from 'react-redux';

export default function useStoreQuoteHealth() {
    const dispatch = useDispatch();

    const executor = (details) => {
        return dispatch({
            type: 'SET_QUOTE_HEALTH_DETAILS',
            payload: details,
        });
    };

    return executor;
};